import React from "react";
import { CloseIcon, CrossIcon } from "../assets/icons";

const Modal = ({
  show,
  onClose,
  onConfirm,
  title,
  description,
  ModalTitle,
  Icon,
  confirmText = "Confirm",
  cancelText = "Cancel",
  ConfirmButtonClass = "login-btn",
  CancelButtonClass = "skip-btn text-blue border-blue",
  children,
}) => {
  if (!show) return null;

  return (
    <div className="fixed m-0 inset-0 flex items-center justify-center z-[999] bg-black/20 backdrop-blur-sm w-full h-full top-0 right-0">
      <div className="bg-white rounded-xl shadow-lg min-w-[500px] max-w-[863px] p-8 relative">
        <button
          className="w-[40px] h-[40px] bg-[#F6F6F6] absolute top-6 right-6 text-2xl text-gray-400 hover:text-gray-800 rounded-[50%] flex items-center justify-center"
          onClick={onClose}
        >
          {CrossIcon}
        </button>
        {ModalTitle && <h2 className="ModalTitle">{ModalTitle}</h2>}

        <div className="mt-[30px] mb-[50px] text-center">
          {Icon && <div className="mb-[20px] flex justify-center">{Icon}
          </div>}
          {title && <p className="text-p !font-bold text-blue">{title}</p>}
          {description && (
            <p className="text-sm text-gray-700 mt-2">{description}</p>
          )}
          {children}
        </div>

        <div className="flex gap-4 justify-end mt-8">

          <button
            onClick={onClose}
            className="btn-light-gray"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className="btn-light-blue"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
